import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0ca3636d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "date-range-container" }
const _hoisted_2 = { class: "date-range-row" }
const _hoisted_3 = { class: "date-input-field" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "date-input-label" }, "Период", -1))
const _hoisted_5 = { class: "date-input-field" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "date-input-label" }, "Дата начала периода", -1))
const _hoisted_7 = { class: "date-input-field" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "date-input-label" }, "Дата окончания", -1))

import { ref, computed, watch } from "vue";
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";

export interface DateRange {
  start_date: Date | null;
  end_date: Date | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DateRangeSelect',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const getDateRange = (type: string): DateRange => {
  const today = new Date();
  today.setHours(23, 59, 59, 999);

  const todayStart = new Date();
  todayStart.setHours(0, 0, 0, 0);

  switch (type) {
    case "yesterday": {
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      const yesterdayStart = new Date(yesterday);
      yesterdayStart.setHours(0, 0, 0, 0);
      return {
        start_date: yesterdayStart,
        end_date: yesterday,
      };
    }
    case "last_7_days": {
      const last7DaysStart = new Date(today);
      last7DaysStart.setDate(last7DaysStart.getDate() - 6);
      last7DaysStart.setHours(0, 0, 0, 0);
      return {
        start_date: last7DaysStart,
        end_date: today,
      };
    }
    case "last_week": {
      const lastWeekEnd = new Date(today);
      lastWeekEnd.setDate(lastWeekEnd.getDate() - today.getDay() - 1);
      const lastWeekStart = new Date(lastWeekEnd);
      lastWeekStart.setDate(lastWeekStart.getDate() - 6);
      lastWeekStart.setHours(0, 0, 0, 0);
      return {
        start_date: lastWeekStart,
        end_date: lastWeekEnd,
      };
    }
    case "this_month": {
      const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
      thisMonthStart.setHours(0, 0, 0, 0);
      return {
        start_date: thisMonthStart,
        end_date: today,
      };
    }
    case "last_month": {
      const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);
      lastMonthEnd.setHours(23, 59, 59, 999);
      const lastMonthStart = new Date(
        today.getFullYear(),
        today.getMonth() - 1,
        1
      );
      lastMonthStart.setHours(0, 0, 0, 0);
      return {
        start_date: lastMonthStart,
        end_date: lastMonthEnd,
      };
    }
    case "last_30_days": {
      const last30Days = new Date(today);
      last30Days.setDate(last30Days.getDate() - 30);
      last30Days.setHours(0, 0, 0, 0);
      return {
        start_date: last30Days,
        end_date: today,
      };
    }
    case "this_year": {
      const thisYearStart = new Date(today.getFullYear(), 0, 1);
      thisYearStart.setHours(0, 0, 0, 0);
      return {
        start_date: thisYearStart,
        end_date: today,
      };
    }
    case "custom": {
      return {
        start_date: null,
        end_date: null,
      };
    }
    default:
      return {
        start_date: null,
        end_date: null,
      };
  }
};

const dateRangeOptions = [
  { label: "Вчера", value: "yesterday" },
  { label: "Последние 7 дней", value: "last_7_days" },
  { label: "Прошлая неделя", value: "last_week" },
  { label: "Этот месяц", value: "this_month" },
  { label: "Прошлый месяц", value: "last_month" },
  { label: "Последние 30 дней", value: "last_30_days" },
  { label: "Этот год", value: "this_year" },
  { label: "Указать период", value: "custom" },
];

const selectedOption = ref<string | null>(null);
const localDateRange = ref<DateRange>({
  start_date: null,
  end_date: null,
});
const lastUserSelection = ref<string | null>(null);

const isCustomPeriod = computed(() => selectedOption.value === "custom");

const compareDates = (date1: Date | null, date2: Date | null): boolean => {
  if (!date1 || !date2) return false;
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};

const checkOrder = [
  "yesterday",
  "last_7_days",
  "last_week",
  "this_month",
  "last_month",
  "last_30_days",
  "this_year",
];

const isThisMonth = (startDate: Date, endDate: Date): boolean => {
  const today = new Date();
  const todayStart = new Date(today.getFullYear(), today.getMonth(), 1);
  todayStart.setHours(0, 0, 0, 0);
  const todayEnd = new Date(today);
  todayEnd.setHours(23, 59, 59, 999);

  return compareDates(startDate, todayStart) && compareDates(endDate, todayEnd);
};

const isThisYear = (startDate: Date, endDate: Date): boolean => {
  const today = new Date();
  const yearStart = new Date(today.getFullYear(), 0, 1);
  yearStart.setHours(0, 0, 0, 0);
  const todayEnd = new Date(today);
  todayEnd.setHours(23, 59, 59, 999);

  return compareDates(startDate, yearStart) && compareDates(endDate, todayEnd);
};

watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue) {
      localDateRange.value = {
        start_date: newValue.start_date ? new Date(newValue.start_date) : null,
        end_date: newValue.end_date ? new Date(newValue.end_date) : null,
      };

      if (lastUserSelection.value === "custom") {
        selectedOption.value = "custom";
        return;
      }

      if (!newValue.start_date || !newValue.end_date) {
        selectedOption.value = null;
      } else {
        const startDate = new Date(newValue.start_date);
        const endDate = new Date(newValue.end_date);

        if (lastUserSelection.value === "custom") {
          selectedOption.value = "custom";
          return;
        }

        if (lastUserSelection.value) {
          const userSelectedRange = getDateRange(lastUserSelection.value);
          if (
            userSelectedRange.start_date &&
            userSelectedRange.end_date &&
            compareDates(userSelectedRange.start_date, startDate) &&
            compareDates(userSelectedRange.end_date, endDate)
          ) {
            selectedOption.value = lastUserSelection.value;
            return;
          }
        }

        let found = false;
        for (const optionValue of checkOrder) {
          const range = getDateRange(optionValue);
          if (
            range.start_date &&
            range.end_date &&
            compareDates(range.start_date, startDate) &&
            compareDates(range.end_date, endDate)
          ) {
            selectedOption.value = optionValue;
            found = true;
            break;
          }
        }
        if (!found) {
          selectedOption.value = "custom";
        }
      }
    } else {
      localDateRange.value = {
        start_date: null,
        end_date: null,
      };
      selectedOption.value = null;
    }
  },
  { immediate: true, deep: true }
);

const handleSelection = (value: string | null) => {
  lastUserSelection.value = value;

  if (!value) {
    selectedOption.value = null;
    localDateRange.value = {
      start_date: null,
      end_date: null,
    };
    emit("update:modelValue", null);
    return;
  }

  selectedOption.value = value;

  if (value === "custom") {
    if (!localDateRange.value.start_date && !localDateRange.value.end_date) {
      emit("update:modelValue", {
        start_date: null,
        end_date: null,
      });
    } else {
      emit("update:modelValue", {
        start_date: localDateRange.value.start_date,
        end_date: localDateRange.value.end_date,
      });
    }
    return;
  }

  const range = getDateRange(value);
  localDateRange.value = {
    start_date: range.start_date ? new Date(range.start_date) : null,
    end_date: range.end_date ? new Date(range.end_date) : null,
  };
  emit("update:modelValue", range);
};

const handleStartDateChange = (
  value: Date | Date[] | (Date | null)[] | null | undefined
) => {
  const date = Array.isArray(value)
    ? (value[0] as Date | null)
    : (value as Date | null);
  localDateRange.value.start_date = date || null;
  if (isCustomPeriod.value) {
    emit("update:modelValue", {
      start_date: date || null,
      end_date: localDateRange.value.end_date,
    });
  }
};

const handleEndDateChange = (
  value: Date | Date[] | (Date | null)[] | null | undefined
) => {
  const date = Array.isArray(value)
    ? (value[0] as Date | null)
    : (value as Date | null);
  localDateRange.value.end_date = date || null;
  if (isCustomPeriod.value) {
    emit("update:modelValue", {
      start_date: localDateRange.value.start_date,
      end_date: date || null,
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(Dropdown), {
          modelValue: selectedOption.value,
          options: dateRangeOptions,
          optionLabel: "label",
          optionValue: "value",
          placeholder: "Выберите значение",
          "onUpdate:modelValue": handleSelection,
          class: "date-range-dropdown"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_unref(Calendar), {
          modelValue: localDateRange.value.start_date,
          "onUpdate:modelValue": handleStartDateChange,
          disabled: !isCustomPeriod.value,
          placeholder: "Выберите дату",
          showIcon: "",
          iconDisplay: "input",
          panelClass: "not-extended"
        }, null, 8, ["modelValue", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_unref(Calendar), {
          modelValue: localDateRange.value.end_date,
          "onUpdate:modelValue": handleEndDateChange,
          disabled: !isCustomPeriod.value,
          placeholder: "Выберите дату",
          showIcon: "",
          iconDisplay: "input",
          panelClass: "not-extended"
        }, null, 8, ["modelValue", "disabled"])
      ])
    ])
  ]))
}
}

})